var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChargerEv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.52 7.22854L19.53 7.21853L16.34 4.02854C16.05 3.73854 15.57 3.73854 15.28 4.02854C14.99 4.31854 14.99 4.79854 15.28 5.08854L16.86 6.66854C15.81 7.06854 15.1 8.13854 15.28 9.37854C15.44 10.4785 16.38 11.3685 17.48 11.4885C17.95 11.5385 18.36 11.4585 18.75 11.2885V18.4985C18.75 19.0485 18.3 19.4985 17.75 19.4985C17.2 19.4985 16.75 19.0485 16.75 18.4985V13.9985C16.75 12.8985 15.85 11.9985 14.75 11.9985H13.75V4.99854C13.75 3.89854 12.85 2.99854 11.75 2.99854H5.75C4.65 2.99854 3.75 3.89854 3.75 4.99854V19.9985C3.75 20.5485 4.2 20.9985 4.75 20.9985H12.75C13.3 20.9985 13.75 20.5485 13.75 19.9985V13.4985H15.25V18.3585C15.25 19.6685 16.19 20.8585 17.49 20.9885C18.99 21.1385 20.25 19.9685 20.25 18.4985V8.99854C20.25 8.30854 19.97 7.67853 19.52 7.22854ZM17.75 9.99854C17.2 9.99854 16.75 9.54854 16.75 8.99854C16.75 8.44853 17.2 7.99854 17.75 7.99854C18.3 7.99854 18.75 8.44853 18.75 8.99854C18.75 9.54854 18.3 9.99854 17.75 9.99854ZM7.75 13.4985V16.1185C7.75 16.6285 8.43 16.8085 8.68 16.3685L11.32 11.7485C11.51 11.4085 11.27 10.9985 10.89 10.9985H9.75V7.99854C9.75 7.47854 9.05 7.30854 8.81 7.75854L6.14 12.7585C5.96 13.0985 6.2 13.4985 6.58 13.4985H7.75Z",
    fill: "#4E5968"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargerEv);
export default __webpack_public_path__ + "static/media/ChargerEV.97c444826de287ba97ddabb32ced84e0.svg";
export { ForwardRef as ReactComponent };